import * as Yup from 'yup';
import { digitsEnToFa } from 'persian-tools2';
import { registerSteps } from 'modules/user/constants/register';

export const validationSchema = (currentStep) => {
  if (currentStep === registerSteps.sendloginCode) {
    return Yup.object({
      phone: Yup.string()
        .trim()
        .matches(/^09\d{9}$/, {
          message: `شماره موبایل باید با ${digitsEnToFa(
            '09'
          )} شروع شود و  ${digitsEnToFa(11)} رقم باشد`
        })
        .required('لطفا شماره موبایل خود را وارد کنید.')
    });
  } else if (currentStep === registerSteps.signup) {
    return Yup.object({
      nationalCode: Yup.string()
        .trim()
        .min(10, `لطفا کد ملی خود را کامل وارد کنید`)
        .required('لطفا کد ملی خود را وارد کنید')
        .matches(/^\d{10}$/i, {
          message: 'کدملی وارد شده صحیح نمی باشد'
        }),
      medicalNumber: Yup.string()
        .trim()
        .min(4, ' لطفا کد نظام پزشکی خود را کامل وارد کنید ')
        .required('لطفا شماره نظام پزشکی خود را وارد کنید')
    });
  } else {
    return Yup.object({
      code: Yup.string()
        .trim()
        .min(4, `لطفا کد را بصورت کامل وارد کنید`)
        .required('لطفا کد ارسال شده به تلفن همراه خود را وارد کنید')
    });
  }
};
